

var Class = require('./class.js');
var Browser = require('./browser.js');
var DOM = require('./dom.js');

module.exports = Class(null, {		// PNGLoader

	__init__: function(dir) {
		this.dir = dir;
	},

	load: function(src, width, height, opts, stretch) {
		if(Browser.isIE6) {
			/* for IE6, create a span, and use the alpha image loader */
			var span = DOM.SPAN(opts);
			span.style.width = width + 'px';
			span.style.height = height + 'px';
			span.style.display = 'inline-block';
			if(stretch)
				span.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + this.dir + src + "', sizingMethod='scale')";
			else
				span.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + this.dir + src + "', sizingMethod='crop')";
			return span;
		}
		else {
			/* for good browsers just create an IMG tag, and return it */
			var img = DOM.IMG(opts);
			img.width = width;
			img.height = height;
			img.style.width = width + 'px';
			img.style.height = height + 'px';
			img.src = this.dir + src;
			return img;
		}
	},

	setsource: function(png, src, stretch) {
		if(Browser.isIE6) {
			if(stretch)
				png.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + this.dir + src + "', sizingMethod='scale')";
			else
				png.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + this.dir + src + "', sizingMethod='crop')";
		}
		else
			png.src = this.dir + src;
	}
});

